__turbopack_context__.v({
  "className": "notokufiarabic_80b9bc36-module__rRGesG__className",
  "variable": "notokufiarabic_80b9bc36-module__rRGesG__variable",
});
